import { render, staticRenderFns } from "./chart4.vue?vue&type=template&id=24abcc52&scoped=true&"
import script from "./chart4.vue?vue&type=script&lang=js&"
export * from "./chart4.vue?vue&type=script&lang=js&"
import style0 from "./chart4.vue?vue&type=style&index=0&id=24abcc52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24abcc52",
  null
  
)

export default component.exports